export default __webpack_public_path__ + "b9b4353a39013b5e8d574b7145788203.png";